var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Exception',{attrs:{"type":"404","img-color":"","desc":_vm.$t('Front_Msg_Exception_404'),"back-text":_vm.$t('Front_Btn_Back_Home')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }